/* eslint-disable react/prop-types */
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo } from "react";
import { getCities, getCountries } from "../../store/resourcesSlice";
import s from "./ExhibitionPreview.module.less";
import { Col, Image, Row } from "antd";
import { mediaUrl } from "../../api/api";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
const ExhibitionPreview = ({ exhibition, isModal = false, isImageDeleted = false }) => {
  const { t } = useTranslation(["ExhibitionPreview", "Countries"]);
  const dispatch = useDispatch();
  const { countries, cities } = useSelector((state) => state.resources);
  const { lang } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!countries.length) {
      dispatch(getCountries());
    }
    if (!cities.length) {
      dispatch(getCities());
    }
  }, []);

  const convertDate = (date) => {
    return date.replaceAll("-", ".");
  };

  const country = useMemo(() => {
    return countries.length > 0 && exhibition.countryId
      ? countries.find((c) => c.id === exhibition.countryId).name
      : undefined;
  }, [countries, exhibition]);

  const city = useMemo(() => {
    return cities.length > 0 && exhibition.countryId
      ? cities.find((c) => c.id === exhibition.cityId).localizedName[lang]
      : undefined;
  }, [cities, exhibition]);

  return (
    <div className={s.preview} style={{ fontWeight: isModal ? 400 : "unset" }}>
      <div className={s.top}>
        <div className={s.details}>
          <div className={s.flex}>
            <div className={s.left}>{t("name")}: </div>
            <div>{exhibition?.exhibitionName}</div>
          </div>
          <div className={s.flex}>
            <div className={s.left} style={{ minWidth: 200 }}>
              {t("site")}:{" "}
            </div>
            <div style={{ wordBreak: "break-word" }}>
              {exhibition?.website ? (
                <a
                  className={"orange blue_hover"}
                  href={exhibition?.website}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {exhibition?.website}
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className={s.flex}>
            <div className={s.left}>{t("country")}: </div>
            <div>{country && t(country, { ns: "Countries" })}</div>
          </div>
          <div className={s.flex}>
            <div className={s.left}>{t("city")}: </div>
            <div>{city && city}</div>
          </div>
          <div className={s.flex}>
            <div className={s.left}>{t("platform")}: </div>
            <div>{exhibition?.areaName}</div>
          </div>
          <div className={s.flex}>
            <div className={s.left}>{t("startDate")}: </div>
            <div>
              {convertDate(
                Array.isArray(exhibition.startDate) ? exhibition.startDate[0] : exhibition.startDate
              )}
            </div>
          </div>
          <div className={s.flex}>
            <div className={s.left}>{t("endDate")}: </div>
            <div>
              {convertDate(
                Array.isArray(exhibition.endDate) ? exhibition.startDate[1] : exhibition.endDate
              )}
            </div>
          </div>
          <div className={s.flex}>
            <div className={s.left}>{t("workingHours")}: </div>
            {console.log(exhibition?.times)}
            <div>
              {exhibition?.times.length > 0 &&
                exhibition?.times.map((t, i) => (
                  <p key={`${i + 1}_${i}`} style={{ fontWeight: isModal ? 400 : "unset" }}>
                    {convertDate(t.startDate.replace(/\d{2}:\d{2}:\d{2}/, ""))}:{" "}
                    {t.timeRange ? t.timeRange[i].startTime : t.startTime} -{" "}
                    {t.timeRange ? t.timeRange[i].endTime : t.endTime}
                  </p>
                ))}
            </div>
          </div>
        </div>
        {!isImageDeleted && exhibition?.logo && (
          <Col span={8}>
            <Image
              className={s.logo}
              src={`${mediaUrl}${exhibition.logo}`}
              preview={{
                toolbarRender: () => <></>
              }}
            />
          </Col>
        )}
      </div>
      <Row className={s.bottom}>
        <Row
          style={{
            flex: 1,
            width: "100%",
            justifyContent: isModal ? "space-between" : "unset"
          }}
        >
          <Col
            style={{
              display: "flex",
              flexDirection: !exhibition?.stand?.passageDiagram ? "row-reverse" : "row",
              justifyContent: "space-between",
              alignItems: "baseline",
              gap: 96,
              paddingRight: "30px"
            }}
          >
            <div>
              <p className={s.descriptionTitle} style={{ textAlign: "left" }}>
                {t("description")}:
              </p>
              <p
                className={s.description}
                style={{
                  marginTop: 18,
                  textAlign: "left",
                  fontWeight: isModal ? 400 : "unset",
                  wordBreak: "break-word"
                }}
              >
                {exhibition?.stand?.description}
              </p>
            </div>
          </Col>
        </Row>
        <Col className={s.rightSide} style={{ flex: 1 }}>
          <Col>
            <div className={s.flex}>
              <div className={s.left}>{t("standNum")}: </div>
              <div>{exhibition?.stand?.boothNumber}</div>
            </div>
            {!isImageDeleted && exhibition?.stand?.passageDiagram && (
              <>
                <p
                  style={{
                    marginTop: 18,
                    marginBottom: 18,
                    textAlign: "left",
                    fontWeight: isModal ? 400 : "unset"
                  }}
                >
                  {t("passWayScheme")}:
                </p>
                <Image
                  className={s.standImg}
                  src={`${mediaUrl}${exhibition.stand.passageDiagram}`}
                  preview={{
                    toolbarRender: () => <></>
                  }}
                />
              </>
            )}
          </Col>
        </Col>
      </Row>
    </div>
  );
};
export default ExhibitionPreview;
